import React, { useEffect, useState } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getFilesNas } from "../../api/Design/filesNasApi";

const normalizePath = (path) =>
  path.replace(/\\/g, "/").replace(/\/+/g, "/").replace(/\/$/, "");

const NASFileManager = ({ initialPath = "", onClose }) => {
  const [currentPath, setCurrentPath] = useState(normalizePath(initialPath));
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Pedir ficheros al backend
  const fetchFiles = async (path) => {
    const normalizedPath = normalizePath(path);

    setLoading(true);
    setError(null);

    try {
      const response = await getFilesNas(normalizedPath);

      setFiles(response);
    } catch (err) {
      console.error("Error fetching NAS files:", err);
      setError("Error al obtener archivos.");
    } finally {
      setLoading(false);
    }
  };

  // Llama al backend cuando cambia currentPath
  useEffect(() => {
    fetchFiles(currentPath);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPath]);

  // Entrar a subcarpeta
  const handleFolderClick = (folderName) => {
    let newPath = currentPath ? `${currentPath}/${folderName}` : folderName;
    newPath = normalizePath(newPath.replace(/^\/+/, "")); // quita barra inicial

    setCurrentPath(newPath);
  };

  // Subir un nivel
  const handleBackClick = () => {
    // Si no hay nada en currentPath, ya estamos en la raiz de iGTextil => no subo
    if (!currentPath) return;
    const parent = currentPath.substring(0, currentPath.lastIndexOf("/")) || "";

    setCurrentPath(parent);
  };

  return (
    <Box sx={{ padding: 2, width: "60em" }}>
      <Typography variant="h6">Explorador de NAS</Typography>
      <Typography variant="body1">
        Ruta actual: {currentPath || "iGTextil"}
      </Typography>

      <Button onClick={onClose} sx={{ marginBottom: 2 }}>
        Cerrar
      </Button>

      {loading && <CircularProgress />}
      {error && <Typography color="error">{error}</Typography>}

      {!loading && !error && (
        <Box>
          {/* Si no estamos en la raíz vacía, mostramos el botón de subir */}
          {currentPath && (
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={handleBackClick}
              sx={{ marginBottom: 2 }}
            >
              Subir un nivel
            </Button>
          )}

          <Box>
            {files
              // Filtra la carpeta base iGTextil si Samba la devuelve
              .filter((file) => {
                // Si currentPath está vacío (""), eso significa “en iGTextil”
                // y Samba a veces devuelve un item con name="iGTextil"
                if (!currentPath && file.name === "iGTextil") {
                  return false;
                }
                return true;
              })
              .map((file) => (
                <Box
                  key={file.name}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: 1,
                    cursor: file.type === "directory" ? "pointer" : "default",
                  }}
                  onClick={
                    file.type === "directory"
                      ? () => handleFolderClick(file.name)
                      : undefined
                  }
                >
                  {file.type === "directory" ? (
                    <FolderIcon />
                  ) : (
                    <InsertDriveFileIcon />
                  )}
                  <Typography sx={{ marginLeft: 1 }}>{file.name}</Typography>
                </Box>
              ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default NASFileManager;
